import { render, staticRenderFns } from "./make-appointments.vue?vue&type=template&id=6749425a&"
import script from "./make-appointments.vue?vue&type=script&lang=js&"
export * from "./make-appointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports